import React, {Component} from 'react';
import { FaTrash, FaEdit } from "react-icons/fa";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Link } from 'react-router-dom';

class ListProductComponent extends Component {
    render() {
        return (
            <tr>
                <td>{ this.props.stt }</td>
                <td>{ this.props.product.name }</td>
                <td>{ this.props.product.type }</td>
                <td dangerouslySetInnerHTML={{
                    __html: this.props.product.info
                }}></td>
                <td>{ this.props.product.price }</td>
                <td>
                    {
                        this.props.product.hidden ? (
                            <b className="text-danger">Ẩn</b>
                        ) : (
                            <span className="text-success">Hiện</span>
                        )
                    }
                </td>
                <td>
                    { this.props.product.description }
                </td>
                <td>
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Chỉnh sửa sản phẩm
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <Link className="btn btn-warning btn-sm mr-1 text-light" to={ "/admin/san-pham/chinh-sua-san-pham/" + this.props.product.id }>
                            <FaEdit />
                        </Link>
                    </OverlayTrigger>
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Xóa sản phẩm
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.props.showModal( this.props.product, 'deleteProduct' ) }>
                            <FaTrash />
                        </button>
                    </OverlayTrigger>
                </td>
            </tr>
        );
    }
}

export default ListProductComponent;